import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, FormControl, FormLabel, Input, Checkbox, useToast, Text, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { useDropzone } from 'react-dropzone';
import PerguntasController from 'controllers/Perguntas/PerguntasController';
import axios from 'axios';

const jwtToken = localStorage.getItem('access_token');

export function METAForm({ questionId, onClose }) {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const toast = useToast();
  const [value, setValue] = useState(0);
  const [file, setFile] = useState(null);
  const { colorMode } = useColorMode();

  const dropzoneStyles = {
    borderWidth: 2,
    borderColor: useColorModeValue('gray.300', 'gray.600'),
    p: 4,
    borderRadius: 'md',
    mt: 4,
    textAlign: 'center',
    bg: useColorModeValue(isDragActive ? 'blue.100' : 'white', isDragActive ? 'blue.800' : 'gray.700'),
    color: useColorModeValue('black', 'white'),
  };

  const handleChange = (event) => {
    setValue(event.target.checked ? 1 : 0);
  };

  const onFileDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    setFile(file);

    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await axios.post('https://app.customervoice.com.br/api/v1/perguntas_page/upload_metadados', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${jwtToken}`,
        },
      });

      if (response.status === 200) {
        toast({
          title: 'Arquivo enviado com sucesso!',
          description: response.data.msg,
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: 'Erro ao enviar o arquivo',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const onSubmit = async (data) => {
    const response = await PerguntasController.AddMeta(questionId, data.de, data.para, value, file);

    if (!response) {
      toast({
        title: 'Erro ao processar',
        description: response.msg,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });

      return;
    }

    onClose();
    toast({
      title: 'Processado com sucesso!',
      description: response.msg,
      status: 'success',
      duration: 5000,
      isClosable: true,
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop: onFileDrop });

  return (
    <Box maxW="md" mx="auto" mt={5} p={5} borderWidth={1} borderRadius="lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl id="new_question" mb={4} isInvalid={!!errors.de || !!errors.para}>
          <FormLabel>Metadados</FormLabel>
          <Input
            {...register("de", { required: 'O campo "de" é obrigatório' })}
            placeholder="Insira o de..."
            mb={2}
          />
          {errors.de && <Text color="red.500" mb={2}>{errors.de.message}</Text>}
          
          <Input
            {...register("para", { required: 'O campo "para" é obrigatório' })}
            placeholder="Insira o até..."
            mb={2}
          />
          {errors.para && <Text color="red.500" mb={2}>{errors.para.message}</Text>}
          
          <Checkbox isChecked={value === 1} onChange={handleChange}>
            Cruzar com a base?
          </Checkbox>
          <Box
            {...getRootProps()}
            {...dropzoneStyles}
          >
            <input {...getInputProps()} />
            {isDragActive ? (
              <Text>Solte o arquivo aqui...</Text>
            ) : (
              <Text>Por favor, faça o upload de um arquivo CSV separado por ponto e vírgula, contendo as colunas 'DE' (dado atual do metadado) e 'PARA' (dado que deve substituir o atual).</Text>
            )}
          </Box>
          {file && (
            <Box mt={4}>
              <Text fontWeight="bold">Arquivo selecionado:</Text>
              <Text>{file.name}</Text>
            </Box>
          )}
        </FormControl>
        <Button type="submit" colorScheme="blue">
          Cadastrar
        </Button>
      </form>
    </Box>
  );
}
